import React from 'react';
import styled from 'styled-components';
import inspireme from '../../assets/project/inspireme_trans.png';

const InspiremeProject = () => {
  return (
    <Container>
      <div className='box'>
        <div className='box-tag'>AI SNS 어시스턴트 툴</div>
        <div className='box-heading'>
          chatGPT
          <br />
          SNS Assistant Tool.
        </div>
        <div className='box-detail'>
          <div className='box-desc-heading'>
            카테고리 기반 큐레이팅 및 chatGPT 모델을 활용한 스타일별 SNS 컨텐츠
            AI 생성 서비스
            <div className='box-desc-list'>
              <div className='box-desc-list-item'>
                텍스트
                <br />
                에디터
              </div>
              <div className='box-desc-list-item'>
                Social Network
                <br />웹 크롤러
              </div>
              <div className='box-desc-list-item'>
                OpenAI GPT
                <br />
                프롬프트 APIs
              </div>
              <div className='box-desc-list-item'>
                chatGPT
                <br />
                스트리밍
              </div>
              <div className='box-desc-list-item'>
                Chrome
                <br />
                Extension
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  grid-column: span 2;

  .box {
    background-color: #181725;
    border-radius: 25px;
    text-align: left;
    padding: 40px;
    background-image: url('${inspireme}');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: right;
  }

  .box-tag {
    margin-bottom: 40px;
    color: #fff;
    font-size: 19px;
    font-weight: 600;
  }

  .box-heading {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-sub-heading {
    font-size: 64px;
    font-weight: 700;
    margin: 0;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-detail {
    font-size: 19px;

    .box-desc-heading {
      color: #fff;
      margin-bottom: 8px;
    }

    .box-description {
      margin: 0;
    }

    .box-desc-list {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 48px;
      font-size: 36px;
      font-weight: 700;

      .box-desc-list-item {
        padding: 12px 18px;
        text-align: center;
      }
    }
  }

  @media only screen and (min-width: 769px) {
    .box {
      background-size: 50%;
    }

    .box-detail {
      .box-desc-list {
        font-size: 56px;
      }
    }
  }
`;

export default InspiremeProject;
